module.exports = __webpack_public_path__ + "img/icon-what-happens.8f7a62b1.svg";